import { render, staticRenderFns } from "./client-dialog-location-image.vue?vue&type=template&id=25b20266&scoped=true"
import script from "./client-dialog-location-image.vue?vue&type=script&lang=js"
export * from "./client-dialog-location-image.vue?vue&type=script&lang=js"
import style0 from "./client-dialog-location-image.vue?vue&type=style&index=0&id=25b20266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b20266",
  null
  
)

export default component.exports